import React, {lazy} from 'react';
import {Navigate, useLocation} from 'react-router-dom';
import GuestGuard from "./core/auth/GuestGuard";
import AuthGuard from "./core/auth/AuthGuard";
import {Loadable} from "./utils/loadable";
import ResetPassword from "./pages/auth/reset-password";

const Login = Loadable(
  lazy(() => import('./pages/auth/login'))
);
const Register = Loadable(
  lazy(() => import('./pages/auth/register'))
);
const Home = Loadable(lazy(() => import('./pages/home')));

const Groups = Loadable(lazy(() => import('./pages/groups')));

const CreateGroupForm = Loadable(lazy(() => import('./core/components/CreateGroupForm/CreateGroupForm')));

const CreateManualReceipt = Loadable(lazy(() => import('./pages/create/manual')));

const CreateScannedReceipt = Loadable(lazy(() => import('./pages/create/scanned')));

const GroupDetails = Loadable(lazy(() => import('./pages/group/details')));

const ReceiptDetails = Loadable(lazy(() => import('./pages/receipt')));
const EditReceipt = Loadable(lazy(() => import('./pages/receipt/edit')));
const SharedReceipt = Loadable(lazy(() => import('./pages/shared/receipt')));

const ReceiptsHistory = Loadable(lazy(() => import('./pages/receipts')));

const Profile = Loadable(lazy(() => import('./pages/profile')));

const RedirectToScannedReceipt = () => {
  const {search, hash, state} = useLocation();
  return <Navigate to={{pathname: '/create/scanned', search, hash}} state={state} replace/>;
};

const routes: any[] = [
  {
    path: '/shared/receipt/:token',
    element: <SharedReceipt/>,
  },
  {
    path: '',
    element: (
      <AuthGuard>
        <Navigate to="/home" replace/>
      </AuthGuard>
    ),
  },
  {
    path: 'login',
    element: (
      <GuestGuard>
        <Login/>
      </GuestGuard>
    ),
  },
  {
    path: 'register',
    element: (
      <GuestGuard>
        <Register/>
      </GuestGuard>
    ),
  },
  {
    path: 'reset-password/:id',
    element: (
      <GuestGuard>
        <ResetPassword/>
      </GuestGuard>
    ),
  },
  {
    path: '/',
    children: [
      {
        path: '/home',
        element: (
          <AuthGuard>
            <Home/>
          </AuthGuard>
        ),
        breadcrumb: 'Home',
      },
      {
        path: '/profile',
        element: (
          <AuthGuard>
            <Profile/>
          </AuthGuard>
        ),
        breadcrumb: 'Home',
      },
      {
        path: '/groups',
        element: (
          <AuthGuard>
            <Groups/>
          </AuthGuard>
        ),
        breadcrumb: 'Groups',
      },
      {
        path: '/groups/create',
        element: (
          <AuthGuard>
            <CreateGroupForm/>
          </AuthGuard>
        ),
      },
      {
        path: 'groups/details/:groupId',
        element: (
          <AuthGuard>
            <GroupDetails/>
          </AuthGuard>
        )
      },
      {
        path: '/create/manual',
        element: (
          <AuthGuard>
            <CreateManualReceipt/>
          </AuthGuard>
        )
      },
      {
        path: '/create/scanned',
        element: (
          <AuthGuard>
            <CreateScannedReceipt/>
          </AuthGuard>
        )
      },
      {
        path: '/create/scaned',
        element: (
          <AuthGuard>
            <RedirectToScannedReceipt/>
          </AuthGuard>
        )
      },
      {
        path: '/receipt/:receiptId/edit',
        element: (
          <AuthGuard>
            <EditReceipt/>
          </AuthGuard>
        ),
      },
      {
        path: '/receipt/:receiptId',
        element: (
          <AuthGuard>
            <ReceiptDetails/>
          </AuthGuard>
        )
      },
      {
        path: '/receipts',
        element: (
          <AuthGuard>
            <ReceiptsHistory/>
          </AuthGuard>
        ),
        breadcrumb: 'History',
      },
    ],
  },
  {
    path: '*',
    element: (
      <AuthGuard>
        <div>not found</div>
      </AuthGuard>
    ),
  },
];

export default routes;
